import App from './App';
// @ts-ignore
export default App;
